import axios from 'axios';

const accessKey = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;
// const secretKey = process.env.REACT_APP_UNSPLASH_SECRET_KEY;

let UnsplashService = {};

// https://api.unsplash.com/search/photos?client_id=LTJyNGcHuqa1iW17fRNq0SfG5jCvBYo8b1KWz2vu408&query=cat

UnsplashService.searchImage = async function (data) {
  try {
    const response = await fetch(`https://api.unsplash.com/search/photos?client_id=${accessKey}&query=${data}&page=1&per_page=50&order_by=popular`);
    
    const res = await response.json()
    const getResult = res.results;
    return getResult;
  } catch (error) {
    console.log(error);
    return null
  }
};

export default UnsplashService;
